// App principale
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Home from "./pages/Home";
// import Login from './pages/Login';
import Navbar from "./components/Navbar";
// import Dashboard from "./pages/Dashboard";
import FactCheck from "./pages/FactCheck";
// import Register from "./pages/Register";
import WhyTrustUs from "./components/WhyTrustUs";
import FAQ from "./components/Faq";
import Contact from "./components/Contact";
import Partners from "./components/NosPartenaires";
import Footer from "./pages/Footer";
import AdvancedChatbox from "./pages/ChatBox";
import VideoDetect from "./pages/VideoDetect";
// import ProtectedRoute from './utils/ProtectedRoute';
// import PageNotFound from "./pages/PageNotFound";
// import AdminDashboard from "./pages/AdminDashboard";
// import Login from "./pages/Login";
// import PrivateRoute from "./routes/PrivateRoute";
// import ProtectedRoute from "./routes/PrivateRoute";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <div className="dark:bg-[#706F6F] text-gray-800 dark:text-white">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/check" element={<FactCheck />} />
          {/* <Route path="/Register" element={<Register />} /> */}
          <Route path="/WhyTrustUs" element={<WhyTrustUs />} />
          <Route path="Faq" element={<FAQ />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Patners" element={<Partners />} />
          <Route path="/ChatBox" element={<AdvancedChatbox />} />
          <Route path="/Videos" element={<VideoDetect />} />
          {/* <Route path="/login" element={<Login />} /> */}
          {/* <Route
            path="/Dashboard"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          /> */}
        </Routes>
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
